
import * as _asset0 from "inline-asset:assets/galleries/test/L1000394-color_85eacc6a9a__20.jpg";
import * as _asset1 from "asset:assets/galleries/test/L1000394-color_85eacc6a9a__400.jpg";
import * as _asset2 from "asset:assets/galleries/test/L1000394-color_85eacc6a9a__800.jpg";
import * as _asset3 from "asset:assets/galleries/test/L1000394-color_85eacc6a9a__1600.jpg";


export default {
  id: "L1000394-color",
  aspect: 1.5124091250940086,
  alt: undefined,
  sources: [{
              url: _asset0.url,
              width: 20,
            },{
              url: _asset1.url,
              width: 400,
            },{
              url: _asset2.url,
              width: 800,
            },{
              url: _asset3.url,
              width: 1600,
            }],
};
        